import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import TemplatesCategorySelect from "./TemplatesCategorySelect";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { fetchCompany, getS3FilebrowserDirectory } from "../actions/index";
import TemplatesFormTinyMCE from "./TemplatesFormTinyMCE";

class TemplatesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    email_template_category_id: PropTypes.number.isRequired,
    categories: PropTypes.array.isRequired,
    videoTemplates: PropTypes.array.isRequired,
    campaigns_using: PropTypes.array,
    match: PropTypes.object.isRequired,
    handleSendTestEmail: PropTypes.func.isRequired,
    getS3FilebrowserDirectory: PropTypes.func.isRequired,
    fetchCompany: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.bodyContent = this.props.body;
    this.state = {
      name: this.props.name,
      email_template_category_id: this.props.email_template_category_id,
      categories: this.props.categories,
      videoTemplates: this.props.videoTemplates,
      subject: this.props.subject,
      body: this.props.body,
      campaigns_using: this.props.campaigns_using,
      site_domain: null,
      showModal: false,
      test_email_address: "",
      errors: {}
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.status == 200) {
        this.setState({ site_domain: response.payload.data.data.site_domain });
      }
    });
  }

  handleChangeName(e) {
    const name = e.target.value;
    this.bodyContent = window.tinyMCE.get("body").getContent();
    this.setState({ name: name });
  }

  handleChangeSubject(e) {
    const subject = e.target.value;
    this.bodyContent = window.tinyMCE.get("body").getContent();
    this.setState({ subject: subject });
  }

  handleSelectCategory(email_template_category_id) {
    this.bodyContent = window.tinyMCE.get("body").getContent();
    this.setState({ email_template_category_id: email_template_category_id });
  }

  handleInsertToken(e) {
    const subject = this.state.subject;
    this.setState({ subject: subject + e.target.value });
    e.target.value = "";
  }

  validateNotEmpty(fieldName, msg, isTinyMCE = false) {
    let value = null;
    if (isTinyMCE) {
      value = window.tinyMCE.get(fieldName).getContent();
    } else {
      value = this.state[fieldName];
    }
    if (value == "") {
      let newError = {};
      newError[fieldName] = msg;
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.setState({ errors: errors });
    }
  }

  validateTokens(fieldName, msg, isTinyMCE = false) {
    let validTokens = [
      "{{LEAD_NAME}}",
      "{{NAME}}",
      "{{LEAD_FIRST_NAME}}",
      "{{FIRST_NAME}}",
      "{{LEAD_LAST_NAME}}",
      "{{LAST_NAME}}",
      "{{LEAD_LOGIN_LINK}}",
      "{{LEAD_EMAIL}}",
      "{{LEAD_UUID}}",
      "{{EMAIL}}",
      "{{PHONE}}",
      "{{LEAD_AVERAGE_PROPERTY_PRICE}}",
      "{{LEAD_APP_LINK}}",
      "{{SENDER_NAME}}",
      "{{AGENT_NAME}}",
      "{{SENDER_FIRST_NAME}}",
      "{{AGENT_FIRST_NAME}}",
      "{{SENDER_LAST_NAME}}",
      "{{AGENT_LAST_NAME}}",
      "{{SENDER_EMAIL}}",
      "{{AGENT_EMAIL}}",
      "{{SENDER_SIGNATURE}}",
      "{{AGENT_EMAIL_SIGNATURE}}",
      "{{SENDER_PHONE}}",
      "{{AGENT_PHONE}}",
      "{{SENDER_PHONE_OFFICE}}",
      "{{AGENT_PHONE_OFFICE}}",
      "{{SENDER_PHONE_CELL}}",
      "{{AGENT_PHONE_CELL}}",
      "{{SENDER_PHONE_HOME}}",
      "{{AGENT_PHONE_HOME}}",
      "{{AGENT_PROFILE_IMAGE}}",
      "{{LEAD_DOWNLOAD_APP_LINK}}",
      "{{LEAD_LOGIN_HERE_LINK}}",
      "{{LEAD_ADVANCED_SEARCH_LINK}}",
      "{{LEAD_SOLD_SEARCH_LINK}}",
      "{{LEAD_MARKET_REPORT_LINK}}",
      "{{SITE}}",
      "{{DAY_OF_WEEK}}",
      "{{CURRENT_MONTH}}"
    ];
    let value = null;
    if (isTinyMCE) {
      value = window.tinyMCE.get(fieldName).getContent();
    } else {
      value = this.state[fieldName];
    }
    let tokens = value.match(/\{{(.*?)\}}/g);
    let invalidList = [];
    if (tokens) {
      invalidList = tokens.filter(token => {
        if (validTokens.includes(token) == false) {
          return token;
        }
      });
    }
    if (invalidList.length > 0) {
      let newError = {};
      newError[fieldName] = msg;
      this.bodyContent = window.tinyMCE.get("body").getContent();
      this.setState({ errors: Object.assign(this.state.errors, newError) });
    } else {
      let errors = this.state.errors;
      delete errors[fieldName];
      this.bodyContent = window.tinyMCE.get("body").getContent();
      this.setState({ errors: errors });
    }
  }

  validate() {
    this.validateNotEmpty("name", "Please enter a name for your email.");
    this.validateNotEmpty("subject", "Please enter a subject for your email.");
    if (this.state.errors.subject === undefined) {
      this.validateTokens(
        "subject",
        "The subject contains invalid merge fields."
      );
    }
    this.validateNotEmpty("body", "Please enter a body for your email.", true);
    if (this.state.errors.body === undefined) {
      this.validateTokens(
        "body",
        "The body contains invalid merge fields.",
        true
      );
    }
  }

  save(e) {
    e.preventDefault();
    this.validate();
    if (Object.keys(this.state.errors).length == 0) {
      let prms = this.state;
      prms.body = window.tinyMCE.get("body").getContent();
      this.props.handleSubmit(prms);
    }
  }

  otherCampaignsUsing() {
    if (this.props.campaigns_using === undefined) {
      return "";
    }
    let otherCampaigns = this.props.campaigns_using.map(campaign_using => {
      if (campaign_using.id != parseInt(this.props.match.params.id)) {
        return campaign_using;
      }
    }, this);
    otherCampaigns = otherCampaigns.filter(function(e) {
      return e;
    });

    if (otherCampaigns.length > 0) {
      return (
        <div className="pull-left m-t-5 text-danger">
          {" "}
          Other Workflows Using: {otherCampaigns.length}{" "}
        </div>
      );
    }
  }

  sendTestEmail() {
    this.validate();
    if (Object.keys(this.state.errors).length == 0) {
      let prms = {
        message: {
          subject: this.state.subject,
          body_text: window.tinyMCE.get("body").getContent()
        }
      };
      this.props.handleSendTestEmail(prms);
    }
  }

  render() {
    let { id, body, subject, name, handleSubmit } = this.props;
    if (!this.state.site_domain) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    if (!body && id) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <div>
        <div
          className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
        >
          <label>Name</label>
          <input
            type="text"
            className="form-control name_field"
            onChange={this.handleChangeName.bind(this)}
            value={this.state.name}
          />
          <div className="help-block">{this.state.errors.name}</div>
        </div>

        <div
          className={`form-group ${
            this.state.errors.category_id ? "has-error" : ""
          }`}
        >
          <label>Category</label>
          <TemplatesCategorySelect
            handleSelectCategory={this.handleSelectCategory.bind(this)}
            match={this.props.match}
            categories={this.state.categories}
            email_template_category_id={this.state.email_template_category_id}
          />
          <div className="help-block">{this.state.errors.category_id}</div>
        </div>

        <div
          className={`form-group ${
            this.state.errors.subject ? "has-error" : ""
          }`}
        >
          <label>Subject</label>
          <select className="fr" onChange={this.handleInsertToken.bind(this)}>
            <option value="">Merge Fields</option>
            <option value="&nbsp;{{NAME}}">Lead - Full Name</option>
            <option value="&nbsp;{{FIRST_NAME}}">Lead - First Name</option>
            <option value="&nbsp;{{LAST_NAME}}">Lead - Last Name</option>
            <option value="&nbsp;{{EMAIL}}">Lead - Email Address</option>
            <option value="&nbsp;{{PHONE}}">Lead - Phone</option>
            <option value="&nbsp;{{LEAD_LOGIN_HERE_LINK}}">Lead - Login Here - Link</option>
            <option value="&nbsp;{{LEAD_AVERAGE_PROPERTY_PRICE}}">
              Lead - Average Property Price
            </option>
            <option value="&nbsp;{{AGENT_NAME}}">Agent - Name</option>
            <option value="&nbsp;{{AGENT_FIRST_NAME}}">
              Agent - First Name
            </option>
            <option value="&nbsp;{{AGENT_LAST_NAME}}">
              Agent - Last Name
            </option>
            <option value="&nbsp;{{AGENT_EMAIL}}">
              Agent - Email Address
            </option>
            <option value="&nbsp;{{AGENT_EMAIL_SIGNATURE}}">
              Agent - Email Signature
            </option>
            <option value="&nbsp;{{AGENT_PHONE}}">
              Agent - Direct Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_OFFICE}}">
              Agent - Office Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_CELL}}">
              Agent - Cell Phone Number
            </option>
            <option value="&nbsp;{{AGENT_PHONE_HOME}}">
              Agent - Home Phone Number
            </option>
            <option value="&nbsp;{{LEAD_DOWNLOAD_APP_LINK}}">Lead - Download App - Link</option>
            <option value="&nbsp;{{LEAD_ADVANCED_SEARCH_LINK}}">Lead - Advanced Search - Link</option>
            <option value="&nbsp;{{LEAD_SOLD_SEARCH_LINK}}">Lead - Sold Search - Link</option>
            <option value="&nbsp;{{LEAD_MARKET_REPORT_LINK}}">Lead - Market Report - Link</option>
            <option value="&nbsp;{{SITE}}">Site</option>
            <option value="&nbsp;{{DAY_OF_WEEK}}">Day of Week</option>
            <option value="&nbsp;{{CURRENT_MONTH}}">Current Month</option>
          </select>
          <input
            type="text"
            className="form-control subject_field"
            onChange={this.handleChangeSubject.bind(this)}
            value={this.state.subject}
          />
          <div className="help-block">{this.state.errors.subject}</div>
        </div>

        <div
          className={`form-group ${this.state.errors.body ? "has-error" : ""}`}
        >
          <label>Body</label>
          <TemplatesFormTinyMCE
            match={this.props.match}
            insertImageUrl={this.insertImageUrl}
            videoTemplates={this.props.videoTemplates}
            getS3FilebrowserDirectory={this.props.getS3FilebrowserDirectory}
            site_domain={this.state.site_domain}
            openModalInS3Modal={this.openModalInS3Modal}
            content={this.bodyContent}
          />
          <div className="help-block">{this.state.errors.body}</div>
        </div>

        <button type="submit" className="btn pull-right btn-primary"
         onClick={this.save.bind(this)}>
          Save
        </button>

        <button
          className="btn pull-right btn-primary m-r-10"
          onClick={this.sendTestEmail.bind(this)}
        >
          Send Test Email
        </button>
        <div className="text-right pull-right m-t-5 p-t-3 m-r-10"
          style={{ color: "#ccc" }}>
          Test Email will be sent to your email.
        </div>
        {this.otherCampaignsUsing()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { fetchCompany, getS3FilebrowserDirectory }
)(TemplatesForm);
